import View from 'view/view'

const ImageListView = View.extend({
    events: {
        'click .js-show-more': '_handleShowMore',
    },

    initialize() {
        this.$items = this.$('.js-imageList-item')
        this.$showMoreButtons = this.$('.js-show-more')
    },

    _handleShowMore() {
        this.$items.removeClass('is-hidden is-shownAboveTablet is-mobileLastElement')
        this.$showMoreButtons.remove()
    },
})

export default ImageListView
